The identifier for the uploaded `Candidate` to be deleted.
